import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import {Description} from 'components/DescriptionList';

const FileSizeDescription = ({showUploadProgress, size, uploadProgress}) => {
	const {t} = useTranslation();

	const progress = ` (${t('form_uploaded_progress', {
		progress: `${Math.ceil(uploadProgress)}%`,
	})})`;

	return (
		<Description title={t('form_file_size_colon')}>
			{size}
			{/* We do not show the upload progress if we are editing an asset and have not added a new file*/}
			{showUploadProgress && progress}
		</Description>
	);
};

export default FileSizeDescription;

FileSizeDescription.propTypes = {
	showUploadProgress: PropTypes.bool,
	size: PropTypes.string,
	uploadProgress: PropTypes.number,
};
